import { deviceDetect } from "../utils/mobile";

window.Drupal.behaviors.loading = {
  attach: (context) => {
    const body = document.querySelector("body");
    body.classList.add("budweiser__block--loading");
    window.addEventListener("load", function () {
      body.classList.remove("budweiser__block--loading");
      let blockLoading = context.querySelector("#block-loading");
      if (blockLoading) {
        blockLoading.remove();
      }
    });
    if (
      document.querySelector("body").classList.contains("node--type-winners") ||
      document
        .querySelector("body")
        .classList.contains("budweiser__budx--page") ||
      document
        .querySelector("body")
        .classList.contains("node--type-semifinalist")
    ) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.addEventListener("DOMContentLoaded", (event) => {
        let lazyPlay = document.querySelectorAll(
          ".field--name-field-video-url"
        );
        for (let index = 0; index < lazyPlay.length; index++) {
          const element = lazyPlay[index];
          let str = element.querySelector("img").src;
          str = str.substring(0, str.length - 4);
          const idvideo = str.replace(
            `${window.location.origin}/sites/default/files/video_thumbnails/`,
            ""
          );
          element.addEventListener("click", function () {
            let idFrame = "";
            setTimeout(() => {
              idFrame = element.querySelector(
                ".video-embed-field-responsive-video"
              ).id = `video-${index}`;
              videoApidatalayer(idFrame, idvideo);
            }, 700);
          });
        }
      });
      function videoApidatalayer(idFrame, idvideo) {
        let player = "";
        const sizeVideoW = deviceDetect.isMobile() ? "300" : "638";
        const sizeVideoH = deviceDetect.isMobile() ? "250" : "358";
        onYouTubePlayerAPIReady();
        function onYouTubePlayerAPIReady() {
          player = new YT.Player(idFrame, {
            height: sizeVideoH,
            width: sizeVideoW,
            videoId: idvideo,
            events: {
              onReady: onPlayerReady,
              onStateChange: onPlayerStateChange,
            },
          });
        }
        function onPlayerReady(evt) {
          evt.target.playVideo();
          dataLayer.push({
            event: "trackEvent",
            eventCategory: "Budweiser - BUDX",
            eventAction: "Serie Somos",
            eventLabel: evt.target.videoTitle,
          });
        }
        function onPlayerStateChange(evt) {}
      }
    }
  },
};

window.Drupal.behaviors.initSession = {
  attach: (context) => {
    const initSession = document.querySelector('.initSession')
    if(initSession) {
      initSession.addEventListener('click', () =>{
        const loginTapit = document.querySelector('#loginTapit')
        loginTapit.click()
      })
    }
  }
}

window.Drupal.behaviors.initSite = {
  attach: (context) => {
    window.addEventListener("DOMContentLoaded", (event) => {
      const bodyHome = document.querySelector('body.path-frontpage')
      if (bodyHome) {
        const bodyHomeModal = document.querySelector('.modal h4.modal-title')
        console.log(bodyHomeModal);
        if(bodyHomeModal.textContent === '') {
          bodyHomeModal.remove()
        }
      }
    });
  }
}




